<template>
  <div id="email-body" class="email contatto" style="position:absolute;top:0;left:0;"  >

    <table cellmargin="0" cellspacing="0" width="760" align="center" border="0" style="border:none;"><tr><td>


      <table cellmargin="0" cellspacing="0" width="760" align="center"><tr> 
        <td width="100%">
          <a href="https://www.innsin.it" style="margin:10px 0 0 0;"><img src="https://www.innsin.it/images/innsin-sin.jpg" style="width:380px;border:none;" /></a>
        </td>
      </tr></table>

<br />
      &#160;
<br />

      <table cellmargin="0" cellspacing="0" width="720" align="center"><tr> 
        <td style="margin:40px 0;">
          Gentile {{contatto.nome }} {{contatto.cognome }}
          <br /><br />
          la presente per confermarLe che il Referente INNSIN {{utente.nome}} {{utente.cognome }} ha aggiunto il Suo nominativo come Utente abilitato alla compilazione delle schede INNSIN per il Centro {{centro.nome}}.
          <br /><br />
          Le Sue credenziali per accedere al sito <a href="https://www.innsin.it/network">https://www.innsin.it</a>  sono le seguenti:
          <br /><br />

        </td>    
      </tr></table>

      <table cellmargin="8" cellspacing="8" width="720" align="center"><tr> 
        <tr>
          <td width="40%">
            <div style="text-align:center;">EMAIL</div>
          </td>
          <td width="60%">
            {{contatto.email}}
          </td>    
        </tr>

        <tr>
          <td width="40%">
            <div style="text-align:center;">PASSWORD</div>
          </td>
          <td width="60%">
            {{contatto.password}}
          </td>    
        </tr>

        <tr>
          <td width="40%">
            &#160;
          </td>
          <td width="60%">
            &#160;
          </td>    
        </tr>
      </table>

      <table cellmargin="0" cellspacing="0" width="720" align="center"><tr> 
        <td style="margin:40px 0;">
           Si ricorda che Lei sarà responsabile della correttezza dei dati e dei contenuti da Lei inseriti o erroneamente modificati o cancellati nella piattaforma INNSIN.
         <br />
         &#160;
         <br />
         &#160;
         </td>    
      </tr></table>



      <table cellmargin="0" cellspacing="0" width="760"><tr> 
        <td style="text-align:center;background:#666666;color:#ffffff;margin:20px;">
          Cordiali saluti
          <br />
          La segreteria INNSIN
        </td>    
      </tr></table>


  </td ></tr></table>
</div>
</template>

<script>
export default {
   props: ['contatto','utente','centro'],
   beforeDestroy: function(){
     console.log("VM DISTRUTTA")
   }
}
</script>
